// extracted by mini-css-extract-plugin
export default {"consent":"Consent_consent__xkodZ","content":"Consent_content__iZdfL","title":"Consent_title__1+FO8","text":"Consent_text__pZZt8","bold":"Consent_bold__lyBw4"};